import React from 'react'
import { useIntl } from 'react-intl'
import Image from 'next/image'

import { Text } from '@/components/common'
import FeaturesPotentialHeader from '@/components/sections/FeaturesPotentialHeader'
import PricingMain from '@/components/blocks/PricingMain'
import BuyTry from '@/components/blocks/BuyTry'
import KeepTrackBox from '@/components/sections/KeepTrackBox'
import CertifiedHardwarePartners from '@/components/sections/CertifiedHardwarePartners'
import CustomerSupport from '@/components/sections/CustomerSupport'
import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import trackReceiptsImg from '@/assets/features-potential/track-receipts.jpg'
import id2Img from '@/assets/tax-prep/id2.png'
import transactionStreamImg from '@/assets/transaction-streaming/transaction-stream.png'
import organiseFilesImg from '@/assets/features-potential/organise-files.jpg'
import organizeFilesImg from '@/assets/features-potential/organize-files.jpg'
import allFilesImg from '@/assets/features-potential/all-files.jpg'

import styles from './neat-features-potentials.module.scss'

const pageId = 'neatFeatures'

export default function NeatFeatures() {
  const { formatMessage } = useIntl()
  const getPageMessage = (id) => formatMessage({ id: `pages.${pageId}.${id}` })

  return (
    <Layout.Content>

      <FeaturesPotentialHeader
        altImgOne={getPageMessage('main.altImgOne')}
        altImgTwo={getPageMessage('main.altImgTwo')}
        descriptionImgOne={getPageMessage('main.descriptionImgOne')}
        descriptionImgTwo={getPageMessage('main.descriptionImgTwo')}
        pathImgOne={organizeFilesImg}
        pathImgTwo={allFilesImg}
        smallPrint={getPageMessage('main.smallPrint')}
        subtitle={getPageMessage('main.subtitle')}
        title={getPageMessage('main.title')}
      />

      <div className={styles.unleashPowerSection}>
        <Section>
          <Rows gap={0}>
            <Row center textCenter>
              <h2 className="c-brand">
                Unleash the power<br />
                of your data
              </h2>
            </Row>
          </Rows>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image
                alt="Track receipts"
                src={trackReceiptsImg}
              />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Track Receipts Everywhere</Text.H2>
                <Text.P>Capture receipts, invoices, and so much more with the snap of a picture. Then upload them
                  straight to Neat using the app. Even email, drag and drop documents into Neat, or import with a
                  compatible scanner.
                </Text.P>
                <Text.P>You’ll always have access to your documents in Neat.</Text.P>
              </Rows>
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center className={styles.textSection} size={50}>
              <Rows className="w-full">
                <Text.H2>Data Extraction</Text.H2>
                <Text.P>Reduce manual data entry with Neat’s powerful, patented OCR technology that accurately extracts
                  key information from your document and turns it into usable data allowing you to enter receipts
                  quickly and accurately.
                </Text.P>
              </Rows>
            </Column>
            <Column center className={styles.imgSection} size={50}>
              <Image alt="Data Extraction" className={styles.dataExtractImg} src={id2Img} style={{ height: 'auto' }} />
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center size={50}>
              <Image alt="Transaction stream" src={transactionStreamImg} style={{ height: 'auto' }} />
            </Column>
            <Column center size={50}>
              <Rows className="w-full">
                <Text.H2>Data Verification</Text.H2>
                <p>Your receipt items are processed using Neat’s unique data identification technology and data is
                  extracted with 99% accuracy.
                </p>
              </Rows>
            </Column>
          </Row>
        </Section>

        <Section paddingTop={0}>
          <Row>
            <Column center className={styles.textSection} size={50}>
              <Rows className="w-full">
                <Text.H2>Organize Files Your Way</Text.H2>
                <Text.P>Organize files by expense type, tax category, and more. Quickly find files with our keyword
                  search and filtering capabilities.
                </Text.P>
              </Rows>
            </Column>
            <Column center className={styles.imgSection} size={50}>
              <Image alt="Organise files" src={organiseFilesImg} style={{ height: 'auto' }} />
            </Column>
          </Row>
        </Section>
      </div>

      <CustomerSupport
        bgFullyVisible
        bgImage="/automated-insights/ai-banner.webp"
        description="Maximize deductions and simplify tax prep—no more last-minute panic."
        title="Stress-Free Tax Season with Paperless Document Management"
      />

      <Section center>
        <Text.H2>Easy and efficient – now that’s Neat!</Text.H2>
        <BuyTry className={styles.ctaButtons} noOutline />
        <Text.P>Neat is a yearly subscription where you can add on solutions.</Text.P>
      </Section>

      <Section>
        <Rows gap={0}>
          <Row center textCenter>
            <h2 className="c-brand">Keep track with ease</h2>
          </Row>
        </Rows>
      </Section>

      <KeepTrackBox smallPrint="Neat is a yearly subscription where you can add on solutions." />

      <CertifiedHardwarePartners />

      <CustomerSupport />

      <Section bgBrandTertiary style={{ backgroundColor: '#E9E8FF' }}>
        <PricingMain hasBottomContent testIdPrefix="pricing-page" />
      </Section>

    </Layout.Content>
  )
}

NeatFeatures.layoutProps = {
  pageId,
}
